import React from 'react';
// @ts-ignore
import styles from './TimelineGridColumn.module.scss';
import TimelineGridColumnItem from './TimelineGridColumnItem';
import { ITimelineGridColumn } from '../../Models/TimelineGrid/ITimelineGridColumn';

export default function TimelineGridColumn(props: ITimelineGridColumn) {
	const { items, title } = props;

	const handleClick = () => {
		console.log('Clicked at title');
		return [];
	};

	return (
		<div className={styles.wrapper}>
			{items.map((item, index) => (
				<React.Fragment key={index}>
					<TimelineGridColumnItem {...item} />
				</React.Fragment>
			))}
			<div className={styles.title} onClick={() => handleClick()}>
				{title}
			</div>
		</div>
	);
}
